export class constants{
    public static readonly statesSearch =  { initSearch: 'initSearch', showResults: 'showResults', showInfo: 'shorInfo'};
}

export const  scoreStates = {
    'VIGENTE' : 'Vigente',
    'VENCIDA' : 'Vencida',
    'NOSCORE' : 'Sin Score',
    'ACTIVO' : 'A',
    'INACTIVO' : 'I',
}

export enum businessScore{
    GT = 'GT',
    SC = 'SC',
    PC = 'PC'
}

export const amaruCodeCountry = {
    CL:'ACHI',
    PE:'APER',
    MX:'AMEX',
    BR:'ABRA'
}

export const MAX_LENGTH_COMMENT = 800;

export const optionalProspectsLabelGroups = ["lbl_garantias_avales","lbl_pro_gt"];

export const REPORT_NAME = "EXCEL_PERSON_SCORES"
export const REPORT_NAME_PC = "EXCEL_PERSON_SCORES_PC"

export const exectuionProcessStates = {
    CREATED: 1,
    PROCESSING: 2,
    FINISHED_SUCCESS: 3,
    FINISHED_ERROR: 4,
    SCHEDULED: 5
}

export const ORIGINS = ['Manual Save', 'REUSE_SC', 'Seguimiento', 'Analytics Automatic Massive'];

export const OPERATION_DIMENSION_CODE = 'lbl_operation'

export enum COMPANY_SCORE_TABS {
    TABLE='TABLE',
    CREATE='CREATE',
    DETAILS='DETAILS'

}

export const ANY_COUNTRY = '*'

export const APP_PREFIX = 'RISK'

export const GROUP_SEPARATOR = "-"